import React from 'react';
import { animated } from 'react-spring';
import PageSvg from '../PageSvg';
import ClickThroughModalWrapper from '../ClickThroughModalWrapper'
import PreviewCompatibleImage from '../PreviewCompatibleImage';

// print sizes
export const FullPage = () => (
  <PageSvg viewBox="0 0 262 370">
    <rect y="0" className="svg_beige" width="262" height="370" />
  </PageSvg>
);
export const HalfPage = () => (
  <PageSvg viewBox="0 0 262 370">
    <rect key="a" y="187" className="svg_beige" width="262" height="183" />
    <rect
      key="b"
      x="120"
      y="-10"
      className="svg_darkbeige"
      width="130"
      height="370"
    />
  </PageSvg>
);
export const QuarterPage = () => (
  <PageSvg viewBox="0 0 262 370">
    <rect key="1" y="280" className="svg_beige" width="262" height="90" />
    <rect
      key="2"
      x="120"
      y="187"
      className="svg_darkbeige"
      width="130"
      height="173"
    />
  </PageSvg>
);
export const EightPage = () => (
  <PageSvg viewBox="0 0 262 370">
    <rect y="280" className="svg_beige" width="130" height="90" />
  </PageSvg>
);
export const Module = () => (
  <PageSvg viewBox="0 0 262 370">
    <rect y="280" className="svg_beige" width="63" height="90" />
  </PageSvg>
);
export const FrontCoverStrip = () => (
  <PageSvg viewBox="0 0 262 370">
    <rect y="320" className="svg_beige" width="262" height="50" />
  </PageSvg>
);
export const Banner = () => (
  <PageSvg viewBox="0 0 262 238">
    <rect key="1" x="15" y="55" className="svg_grey" width="116" height="155" />
    <rect
      key="2"
      x="134"
      y="55"
      className="svg_grey"
      width="116"
      height="155"
    />
    <rect
      key="3"
      x="57.5"
      y="20"
      className="svg_highlight"
      width="147"
      height="18"
    />
  </PageSvg>
);

// epaper sizes
export const Interstitial = (props) => (
  <PageSvg {...props} viewBox="0 0 262 238">
    <rect x="60" y="22" className="svg_highlight" width="144" height="192" />
  </PageSvg>
);

// online sizes
export const Leaderboard = (props) => (
  <PageSvg {...props} viewBox="0 0 300 300">
    <rect
      key="1"
      x="192.5"
      y="0"
      className="svg_grey"
      width="68"
      height="104"
    />
    <rect
      key="2"
      x="68.5"
      y="118"
      className="svg_highlight"
      width="163"
      height="22"
    />
    <g key="3">
      <rect x="40.5" y="156" className="svg_grey" width="22" height="6" />
      <g>
        <g>
          <rect x="40.5" y="199" className="svg_white" width="52" height="19" />
          <rect x="40.5" y="167" className="svg_grey" width="52" height="32" />
        </g>
        <g>
          <rect x="96.5" y="199" className="svg_white" width="52" height="19" />
          <rect x="96.5" y="167" className="svg_grey" width="52" height="32" />
        </g>
        <g>
          <rect
            x="152.5"
            y="199"
            className="svg_white"
            width="52"
            height="19"
          />
          <rect x="152.5" y="167" className="svg_grey" width="52" height="32" />
        </g>
        <g>
          <rect
            x="208.5"
            y="199"
            className="svg_white"
            width="52"
            height="19"
          />
          <rect x="208.5" y="167" className="svg_grey" width="52" height="32" />
        </g>
      </g>
    </g>
    <g key="4">
      <g>
        <g>
          <rect x="40.5" y="271" className="svg_white" width="52" height="19" />
          <rect x="40.5" y="239" className="svg_grey" width="52" height="32" />
        </g>
        <g>
          <rect x="96.5" y="271" className="svg_white" width="52" height="19" />
          <rect x="96.5" y="239" className="svg_grey" width="52" height="32" />
        </g>
        <g>
          <rect
            x="152.5"
            y="271"
            className="svg_white"
            width="52"
            height="19"
          />
          <rect x="152.5" y="239" className="svg_grey" width="52" height="32" />
        </g>
        <g>
          <rect
            x="208.5"
            y="271"
            className="svg_white"
            width="52"
            height="19"
          />
          <rect x="208.5" y="239" className="svg_grey" width="52" height="32" />
        </g>
      </g>
      <g>
        <rect x="40.5" y="228" className="svg_grey" width="40" height="5" />
      </g>
    </g>
    <g key="5">
      <rect x="94" y="47" className="svg_grey" width="89.5" height="6" />
      <polygon
        className="svg_grey"
        points="183.5,55 94,55 94,67 94,68 94,73 127.2,73 127.2,68 183.5,68 		"
      />
      <rect x="40.5" y="46" className="svg_grey" width="48.5" height="31" />
      <rect x="40.5" y="85" className="svg_grey" width="68" height="7" />
      <polygon
        className="svg_grey"
        points="183.5,94 96.9,94 91.6,94 40.5,94 40.5,102 96.9,102 96.9,98 183.5,98 		"
      />
      <rect x="40.5" y="0" className="svg_grey" width="143" height="37" />
    </g>
  </PageSvg>
);

export const Billboard = (props) => (
  <PageSvg {...props} viewBox="0 0 300 300">
    <rect
      key="1"
      className="svg_highlight"
      x="40.5"
      y="145"
      width="219"
      height="57"
    />
    <rect
      key="2"
      className="svg_grey"
      x="192.6"
      y="212"
      width="67"
      height="88"
    />
    <g key="3">
      <rect className="svg_grey" x="40" y="212" width="144" height="88" />
      <rect className="svg_white" x="53.69" y="258" width="118" height="8" />
      <rect className="svg_white" x="82.69" y="268" width="60" height="8" />
      <rect className="svg_white" x="58.69" y="281" width="108" height="3" />
      <rect className="svg_white" x="103.69" y="289" width="18" height="3" />
      <rect className="svg_white" x="60.19" y="285" width="105" height="3" />
    </g>
    <g key="4">
      <rect className="svg_grey" x="40.4" y="49" width="219.6" height="87" />
      <rect className="svg_white" x="52" y="68" width="50" height="8" />
      <rect className="svg_white" x="52" y="79" width="60" height="8" />
      <rect className="svg_white" x="52" y="90" width="44" height="8" />
      <rect className="svg_white" x="52" y="107" width="108" height="3" />
      <rect className="svg_white" x="52" y="115" width="18" height="3" />
      <rect className="svg_white" x="52" y="111" width="105" height="3" />
    </g>
    <g key="5">
      <rect className="svg_grey" width="300" height="40" />
      <g>
        <path
          className="svg_white"
          d="M80.34,24.14l-.4,2.33H77.31l2.51-11.81h3.29l2.16,11.81H82.64l-.39-2.33ZM82,22.06l-.29-2.25c-.09-.66-.25-1.94-.35-2.68h0c-.12.74-.3,2.05-.4,2.68l-.35,2.25Z"
        />
        <path
          className="svg_white"
          d="M92.73,23.72c0,.91,0,1.88.07,2.75H90.47l-.14-.91h0a2.45,2.45,0,0,1-2,1.05c-1.7,0-2.39-1.22-2.39-3.62V17.85h2.72v4.86c0,1,.23,1.64.74,1.64a.58.58,0,0,0,.54-.35,1.47,1.47,0,0,0,.16-.72V17.85h2.71Z"
        />
        <path
          className="svg_white"
          d="M94.15,24.13a3.61,3.61,0,0,0,1.63.45c.51,0,.79-.17.79-.56s-.26-.56-1-.95a2.69,2.69,0,0,1-1.75-2.48,2.81,2.81,0,0,1,3-2.88,4.39,4.39,0,0,1,1.84.39l-.42,2a2.64,2.64,0,0,0-1.23-.33c-.53,0-.75.26-.75.58s.19.47,1,.91A2.8,2.8,0,0,1,99,23.79c0,1.79-1.3,2.79-3.25,2.79a4,4,0,0,1-2.06-.49Z"
        />
        <path
          className="svg_white"
          d="M103.07,15.52v2.33h1.7v1.89h-1.7v3.44c0,.95.43,1.17.86,1.17a3.28,3.28,0,0,0,.63-.05v2.12a6.75,6.75,0,0,1-1.57.16,2.69,2.69,0,0,1-1.81-.56,3.19,3.19,0,0,1-.82-2.6V19.74h-1V17.85h1V16.31Z"
        />
        <path
          className="svg_white"
          d="M105.72,20.6c0-.91,0-1.87-.07-2.75H108l.14,1.23h.07a2,2,0,0,1,1.67-1.37,2.75,2.75,0,0,1,.58.05v2.67a2.74,2.74,0,0,0-.6,0,1.35,1.35,0,0,0-1.28,1,2.77,2.77,0,0,0-.12.9v4.2h-2.72Z"
        />
        <path
          className="svg_white"
          d="M117.34,24.49a12.13,12.13,0,0,0,.14,2h-2.42l-.14-.82h0a2.39,2.39,0,0,1-2,1,2.46,2.46,0,0,1-2.37-2.68c0-2.31,2.1-3.22,4-3.24v-.16c0-.47-.44-.84-1.14-.84a3.46,3.46,0,0,0-1.89.53l-.48-1.81a6.61,6.61,0,0,1,3-.7c3,0,3.29,2.14,3.29,3.8Zm-2.66-2.1c-.79,0-1.6.33-1.6,1.25,0,.73.44,1,.74,1a.82.82,0,0,0,.8-.51.85.85,0,0,0,.06-.35Z"
        />
        <path className="svg_white" d="M118.67,14.35h2.72V26.47h-2.72Z" />
        <path
          className="svg_white"
          d="M125.4,15.56A1.33,1.33,0,0,1,124,17a1.31,1.31,0,0,1-1.3-1.4,1.33,1.33,0,1,1,2.66,0Zm-2.66,10.91V17.85h2.72v8.62Z"
        />
        <path
          className="svg_white"
          d="M133.15,24.49a11.11,11.11,0,0,0,.14,2h-2.42l-.14-.82h0a2.39,2.39,0,0,1-2,1,2.46,2.46,0,0,1-2.37-2.68c0-2.31,2.1-3.22,4.05-3.24v-.16c0-.47-.44-.84-1.14-.84a3.43,3.43,0,0,0-1.89.53l-.48-1.81a6.56,6.56,0,0,1,3-.7c3,0,3.3,2.14,3.3,3.8Zm-2.66-2.1c-.79,0-1.6.33-1.6,1.25,0,.73.44,1,.74,1a.83.83,0,0,0,.8-.51.85.85,0,0,0,.06-.35Z"
        />
        <path
          className="svg_white"
          d="M134.46,20.6c0-.91,0-1.87-.07-2.75h2.33l.14,1h0A2.57,2.57,0,0,1,139,17.71c1.82,0,2.38,1.49,2.38,3.35v5.41H138.7V21.15c0-.6-.15-1.16-.7-1.16a.75.75,0,0,0-.68.51,2.13,2.13,0,0,0-.14.8v5.17h-2.72Z"
        />
        <path
          className="svg_white"
          d="M147.12,14.66h2.71v7.85c0,3.74-1.89,4.1-3.55,4.1a3.71,3.71,0,0,1-1.28-.19l.22-2.28a2.64,2.64,0,0,0,.79.11c.55,0,1.11-.23,1.11-1.6Z"
        />
        <path
          className="svg_white"
          d="M153.41,23.28c0,.79.7,1.27,1.73,1.27a5.91,5.91,0,0,0,1.74-.28l.33,1.92a8.11,8.11,0,0,1-2.56.39c-2.47,0-3.85-1.49-3.85-4.21,0-2.94,1.65-4.66,3.68-4.66s3.14,1.3,3.14,4.19a7.35,7.35,0,0,1-.09,1.38Zm1.77-1.87c0-.84-.14-1.75-.84-1.75s-.93,1-.93,1.75Z"
        />
        <path
          className="svg_white"
          d="M160.72,17.85l.3,3.51c.08.94.17,1.77.22,2.56h.06c.12-.79.28-1.7.43-2.53l.67-3.54h2.09l.63,3.47c.17,1,.31,1.81.4,2.6h0c.06-.78.13-1.69.23-2.6l.41-3.47h2.68l-2.25,8.62h-2.33L163.8,24a24.92,24.92,0,0,1-.42-2.74h0a23.36,23.36,0,0,1-.49,2.74l-.62,2.5h-2.33l-2.12-8.62Z"
        />
        <path
          className="svg_white"
          d="M172.18,15.56a1.34,1.34,0,0,1-1.37,1.4,1.3,1.3,0,0,1-1.29-1.4,1.33,1.33,0,1,1,2.66,0Zm-2.66,10.91V17.85h2.71v8.62Z"
        />
        <path
          className="svg_white"
          d="M173.6,24.13a3.57,3.57,0,0,0,1.63.45c.51,0,.79-.17.79-.56s-.27-.56-1-.95a2.71,2.71,0,0,1-1.75-2.48,2.81,2.81,0,0,1,3-2.88,4.35,4.35,0,0,1,1.84.39l-.42,2a2.56,2.56,0,0,0-1.22-.33c-.53,0-.76.26-.76.58s.19.47,1,.91a2.78,2.78,0,0,1,1.72,2.57c0,1.79-1.3,2.79-3.24,2.79a4.08,4.08,0,0,1-2.07-.49Z"
        />
        <path
          className="svg_white"
          d="M179.21,14.35h2.71v4.4h0a2.57,2.57,0,0,1,.75-.72,2.4,2.4,0,0,1,1.18-.32c1.78,0,2.28,1.56,2.28,3.75v5h-2.72v-5.1c0-.73-.12-1.38-.72-1.38-.28,0-.54.12-.7.58a2.74,2.74,0,0,0-.11.65v5.25h-2.71Z"
        />
        <path
          className="svg_white"
          d="M191,26.47V14.66h2.48l1.66,4.24c.3.76.86,2.25,1.16,3.16h0c-.07-1-.26-3.26-.26-5.49V14.66h2.37V26.47h-2.48l-1.59-4a30.62,30.62,0,0,1-1.12-3.35h0c.06,1,.16,3,.16,5.29v2Z"
        />
        <path
          className="svg_white"
          d="M201.82,23.28c0,.79.7,1.27,1.73,1.27a6,6,0,0,0,1.74-.28l.33,1.92a8.11,8.11,0,0,1-2.56.39c-2.47,0-3.86-1.49-3.86-4.21,0-2.94,1.65-4.66,3.68-4.66S206,19,206,21.9a6.55,6.55,0,0,1-.09,1.38Zm1.77-1.87c0-.84-.14-1.75-.85-1.75s-.92,1-.92,1.75Z"
        />
        <path
          className="svg_white"
          d="M209.12,17.85l.3,3.51c.09.94.18,1.77.23,2.56h0c.12-.79.28-1.7.44-2.53l.67-3.54h2.08l.63,3.47c.18,1,.32,1.81.41,2.6h0c0-.78.12-1.69.23-2.6l.4-3.47h2.68L215,26.47H212.7l-.49-2.5a24.92,24.92,0,0,1-.42-2.74h0a21.45,21.45,0,0,1-.49,2.74l-.61,2.5h-2.33l-2.12-8.62Z"
        />
        <path
          className="svg_white"
          d="M217.82,24.13a3.57,3.57,0,0,0,1.63.45c.5,0,.78-.17.78-.56s-.26-.56-1-.95a2.71,2.71,0,0,1-1.75-2.48,2.81,2.81,0,0,1,3-2.88,4.35,4.35,0,0,1,1.84.39l-.42,2a2.57,2.57,0,0,0-1.23-.33c-.52,0-.75.26-.75.58s.19.47,1,.91a2.78,2.78,0,0,1,1.72,2.57c0,1.79-1.3,2.79-3.24,2.79a4.06,4.06,0,0,1-2.07-.49Z"
        />
        <g>
          <g>
            <path
              className="svg_white"
              d="M86.15,14.9h-.87v-.4h2.3v.4H86.7v2.22h-.55Z"
            />
            <path
              className="svg_white"
              d="M88.51,14.5v1.05h1.28V14.5h.56v2.62h-.56V16H88.51v1.15H88V14.5Z"
            />
            <path
              className="svg_white"
              d="M92.72,16H91.57v.77h1.28v.39H91V14.5h1.77v.39H91.57v.68h1.15Z"
            />
          </g>
          <g>
            <path
              className="svg_white"
              d="M86.15,14.9h-.87v-.4h2.3v.4H86.7v2.22h-.55Z"
            />
            <path
              className="svg_white"
              d="M88.51,14.5v1.05h1.28V14.5h.56v2.62h-.56V16H88.51v1.15H88V14.5Z"
            />
            <path
              className="svg_white"
              d="M92.72,16H91.57v.77h1.28v.39H91V14.5h1.77v.39H91.57v.68h1.15Z"
            />
          </g>
        </g>
      </g>
    </g>
  </PageSvg>
);

const HalfPageSidebar = (props) => (
  <PageSvg {...props} viewBox="0 0 300 300">
    <g key="1">
      <rect x="571.3" y="56" className="svg_grey" width="97" height="8" />
      <rect x="548" y="68" className="svg_grey" width="46" height="30" />
      <rect x="597" y="68" className="svg_grey" width="46" height="30" />
      <rect x="646" y="68" className="svg_grey" width="46" height="30" />
    </g>
    <rect
      key="2"
      x="700.6"
      y="-32"
      className="svg_grey"
      width="67"
      height="85"
    />
    <rect
      key="3"
      x="700.6"
      y="63"
      className="svg_grey"
      width="67"
      height="56"
    />
    <g key="4">
      <rect x="548.4" y="-32" className="svg_grey" width="144" height="77" />
      <rect x="561.7" y="4" className="svg_white" width="118" height="8" />
      <rect x="590.7" y="14" className="svg_white" width="60" height="8" />
      <rect x="566.7" y="27" className="svg_white" width="108" height="3" />
      <rect x="611.7" y="35" className="svg_white" width="18" height="3" />
      <rect x="568.2" y="31" className="svg_white" width="105" height="3" />
    </g>
    <rect
      key="5"
      x="547.5"
      y="110"
      className="svg_grey"
      width="144"
      height="43"
    />
    <g key="6">
      <rect x="547.5" y="161" className="svg_grey" width="144" height="96" />
      <rect x="646.5" y="176" className="svg_white" width="40" height="26" />
      <rect x="552.5" y="177" className="svg_white" width="85" height="53" />
      <rect x="646.5" y="207" className="svg_white" width="40" height="3" />
      <rect x="646.5" y="225" className="svg_white" width="35" height="3" />
      <rect x="646.5" y="210" className="svg_white" width="19" height="3" />
      <rect x="646.5" y="228" className="svg_white" width="12" height="3" />
      <rect x="552.5" y="234" className="svg_white" width="72" height="4" />
      <rect x="551.5" y="242" className="svg_white" width="75" height="3" />
      <rect x="551.5" y="245" className="svg_white" width="86" height="3" />
      <rect x="551.5" y="248" className="svg_white" width="45" height="3" />
      <rect x="552.5" y="165" className="svg_white" width="36" height="5" />
    </g>
    <rect
      key="7"
      x="700.5"
      y="129"
      className="svg_highlight"
      width="67"
      height="134"
    />
    <g key="8">
      <rect x="40.4" y="9" className="svg_grey" width="46" height="30" />
      <rect x="89.4" y="9" className="svg_grey" width="46" height="30" />
      <rect x="138.4" y="9" className="svg_grey" width="46" height="30" />
    </g>
    <rect key="9" x="193.1" y="4" className="svg_grey" width="67" height="56" />
    <rect
      key="10"
      x="39.9"
      y="51"
      className="svg_grey"
      width="144"
      height="43"
    />
    <g key="11">
      <rect x="39.9" y="102" className="svg_grey" width="144" height="96" />
      <rect x="138.9" y="117" className="svg_white" width="40" height="26" />
      <rect x="44.9" y="118" className="svg_white" width="85" height="53" />
      <rect x="138.9" y="148" className="svg_white" width="40" height="3" />
      <rect x="138.9" y="166" className="svg_white" width="35" height="3" />
      <rect x="138.9" y="151" className="svg_white" width="19" height="3" />
      <rect x="138.9" y="169" className="svg_white" width="12" height="3" />
      <rect x="44.9" y="175" className="svg_white" width="72" height="4" />
      <rect x="43.9" y="183" className="svg_white" width="75" height="3" />
      <rect x="43.9" y="186" className="svg_white" width="86" height="3" />
      <rect x="43.9" y="189" className="svg_white" width="45" height="3" />
      <rect x="44.9" y="106" className="svg_white" width="36" height="5" />
    </g>
    <rect
      key="12"
      x="192.9"
      y="70"
      className="svg_highlight"
      width="67"
      height="134"
    />
    <rect
      key="13"
      x="40.5"
      y="208"
      className="svg_grey"
      width="144"
      height="85"
    />
    <g key="14">
      <rect x="193.5" y="213" className="svg_grey" width="67" height="81" />
      <rect x="196.5" y="219" className="svg_white" width="38" height="5" />
      <g>
        <rect x="197.5" y="237" className="svg_white" width="12" height="12" />
        <rect x="211.5" y="237" className="svg_white" width="16" height="3" />
        <rect x="211.5" y="241" className="svg_white" width="37" height="3" />
        <rect x="211.5" y="245" className="svg_white" width="28" height="3" />
      </g>
      <g>
        <rect x="197.5" y="257" className="svg_white" width="12" height="12" />
        <rect x="211.5" y="257" className="svg_white" width="16" height="3" />
        <rect x="211.5" y="261" className="svg_white" width="37" height="3" />
        <rect x="211.5" y="265" className="svg_white" width="28" height="3" />
      </g>
      <g>
        <rect x="197.5" y="276" className="svg_white" width="12" height="12" />
        <rect x="211.5" y="276" className="svg_white" width="16" height="3" />
        <rect x="211.5" y="280" className="svg_white" width="37" height="3" />
        <rect x="211.5" y="284" className="svg_white" width="28" height="3" />
      </g>
    </g>
  </PageSvg>
);

const MrecSidebar = (props) => (
  <PageSvg {...props} viewBox="0 0 300 300">
    <g key="1">
      <rect x="63.3" y="89" className="svg_grey" width="97" height="8" />
      <rect x="40" y="101" className="svg_grey" width="46" height="30" />
      <rect x="89" y="101" className="svg_grey" width="46" height="30" />
      <rect x="138" y="101" className="svg_grey" width="46" height="30" />
    </g>
    <rect key="2" x="192.6" y="1" className="svg_grey" width="67" height="85" />
    <rect
      key="3"
      x="192.6"
      y="96"
      className="svg_highlight"
      width="67"
      height="56"
    />
    <g key="4">
      <rect x="40.4" y="1" className="svg_grey" width="144" height="77" />
      <rect x="53.7" y="37" className="svg_white" width="118" height="8" />
      <rect x="82.7" y="47" className="svg_white" width="60" height="8" />
      <rect x="58.7" y="60" className="svg_white" width="108" height="3" />
      <rect x="103.7" y="68" className="svg_white" width="18" height="3" />
      <rect x="60.2" y="64" className="svg_white" width="105" height="3" />
    </g>
    <rect
      key="5"
      x="39.5"
      y="143"
      className="svg_grey"
      width="144"
      height="43"
    />
    <g key="6">
      <rect x="39.5" y="194" className="svg_grey" width="144" height="96" />
      <rect x="138.5" y="209" className="svg_white" width="40" height="26" />
      <rect x="44.5" y="210" className="svg_white" width="85" height="53" />
      <rect x="138.5" y="240" className="svg_white" width="40" height="3" />
      <rect x="138.5" y="258" className="svg_white" width="35" height="3" />
      <rect x="138.5" y="243" className="svg_white" width="19" height="3" />
      <rect x="138.5" y="261" className="svg_white" width="12" height="3" />
      <rect x="44.5" y="267" className="svg_white" width="72" height="4" />
      <rect x="43.5" y="275" className="svg_white" width="75" height="3" />
      <rect x="43.5" y="278" className="svg_white" width="86" height="3" />
      <rect x="43.5" y="281" className="svg_white" width="45" height="3" />
      <rect x="44.5" y="198" className="svg_white" width="36" height="5" />
    </g>
    <rect
      key="7"
      x="192.5"
      y="162"
      className="svg_grey"
      width="67"
      height="134"
    />
  </PageSvg>
);

const MrecInline = (props) => (
  <PageSvg {...props} viewBox="0 0 300 300">
    <rect key="1" x="189" y="5" className="svg_grey" width="67" height="134" />
    <g key="2">
      <polygon
        className="svg_grey"
        points="46,7 46,17 46,27 102.9,27 102.9,17 178,17 178,7 		"
      />
      <polygon
        className="svg_grey"
        points="46,30 46,48 46,53 104,53 104,48 179,48 179,30 		"
      />
      <rect x="46" y="59" className="svg_grey" width="50" height="4" />
    </g>
    <g key="3">
      <rect x="46" y="69" className="svg_grey" width="136" height="85" />
      <polygon
        className="svg_grey"
        points="182,157 46,157 46,159 46,160 46,163 84,163 84,160 182,160 		"
      />
    </g>
    <rect key="4" x="189" y="146" className="svg_grey" width="67" height="57" />
    <g key="5">
      <polygon
        className="svg_grey"
        points="46,168 46,196 46,201 58,201 58,196 182,196 182,168 		"
      />
      <polygon
        className="svg_grey"
        points="181,208 46,208 46,217 46,218 46,223 121,223 121,218 181,218 		"
      />
      <rect x="80" y="230" className="svg_highlight" width="68" height="57" />
      <rect x="46" y="293" className="svg_grey" width="136" height="7" />
    </g>
  </PageSvg>
);
const EmailBanner = (props) => (
  <PageSvg {...props} viewBox="0 0 262 238">
    <g key="1">
      <rect className="svg_grey" x="78" y="112.5" width="144" height="77" />
      <rect className="svg_white" x="91.29" y="148.5" width="118" height="8" />
      <rect className="svg_white" x="120.29" y="158.5" width="60" height="8" />
      <rect className="svg_white" x="96.29" y="171.5" width="108" height="3" />
      <rect className="svg_white" x="141.29" y="179.5" width="18" height="3" />
      <rect className="svg_white" x="97.79" y="175.5" width="105" height="3" />
    </g>
    <g key="2">
      <rect className="svg_highlight" x="78" y="8.5" width="144" height="96" />
      <rect className="svg_white" x="86" y="16.5" width="129" height="61" />
      <rect className="svg_white" x="86" y="82.5" width="72" height="4" />
      <rect className="svg_white" x="86" y="90.5" width="75" height="3" />
      <rect className="svg_white" x="86" y="95.5" width="45" height="3" />
    </g>
    <g key="3">
      <rect
        className="svg_grey"
        x="179.42"
        y="211.27"
        width="42.79"
        height="27.81"
      />
      <rect
        className="svg_grey"
        x="78.86"
        y="212.34"
        width="90.93"
        height="56.7"
      />
      <rect
        className="svg_grey"
        x="179.42"
        y="244.43"
        width="42.79"
        height="3.21"
      />
      <rect
        className="svg_grey"
        x="179.42"
        y="263.69"
        width="37.44"
        height="3.21"
      />
      <rect
        className="svg_grey"
        x="179.42"
        y="247.64"
        width="20.33"
        height="3.21"
      />
      <rect
        className="svg_grey"
        x="179.42"
        y="266.9"
        width="12.84"
        height="3.21"
      />
      <rect
        className="svg_grey"
        x="78.86"
        y="273.31"
        width="77.02"
        height="4.28"
      />
      <rect
        className="svg_grey"
        x="77.79"
        y="281.87"
        width="80.23"
        height="3.21"
      />
      <rect
        className="svg_grey"
        x="77.79"
        y="285.08"
        width="92"
        height="3.21"
      />
      <rect
        className="svg_grey"
        x="77.79"
        y="288.29"
        width="48.14"
        height="3.21"
      />
      <rect
        className="svg_grey"
        x="78.86"
        y="199.5"
        width="38.51"
        height="5.35"
      />
    </g>

    {/*  <g key="1">
      <rect x="36.884" y="206.515" className="svg_grey" width="188.164" height="12.191" />
      <rect x="36.884" y="223.048" className="svg_grey" width="188.164" height="4.253" />
      <rect x="36.884" y="232.062" className="svg_grey" width="187.477" height="4.253" />
      <rect x="36.884" y="241.076" className="svg_grey" width="187.477" height="4.253" />
      <rect x="36.884" y="90.271" className="svg_grey" width="187.477" height="105.565" />
    </g>
    <g key="2">
      <rect x="36.952" y="39.684" className="svg_highlight" width="188.096" height="37.619" />
    </g>
    <g key="3" id="Layer_2_1_">
      <g key="4" id="Layer_1-2">
        <rect x="36.952" y="12.177" className="svg_grey" width="188.096" height="14.539" />
        <path
          className="svg_light"
          d="M46.022,21.846l-0.253,1.506h-1.698l1.613-7.606h2.122l1.391,7.606h-1.696l-0.249-1.506H46.022z
          M47.117,20.503l-0.192-1.439c-0.057-0.429-0.158-1.253-0.225-1.727h-0.023c-0.078,0.474-0.192,1.32-0.259,1.727l-0.226,1.444
          L47.117,20.503z"
        />
        <path
          className="svg_light"
          d="M54.001,21.58c0,0.587,0.023,1.208,0.046,1.77h-1.501l-0.09-0.587h-0.023c-0.3,0.432-0.795,0.685-1.32,0.676
          c-1.095,0-1.535-0.79-1.535-2.335V17.8h1.749v3.126c0,0.666,0.147,1.061,0.474,1.061c0.151,0.001,0.289-0.088,0.35-0.226
          c0.072-0.144,0.106-0.303,0.101-0.463V17.8h1.749V21.58z"
        />
        <path
          className="svg_light"
          d="M54.915,21.839c0.321,0.18,0.681,0.281,1.049,0.293c0.327,0,0.506-0.113,0.506-0.362
          s-0.169-0.362-0.621-0.609c-0.981-0.53-1.128-1.151-1.128-1.602c0-1.038,0.733-1.851,1.952-1.851
          c0.409-0.002,0.813,0.084,1.185,0.253l-0.271,1.264c-0.242-0.135-0.513-0.209-0.79-0.215c-0.339,0-0.486,0.169-0.486,0.373
          c0,0.204,0.126,0.305,0.632,0.587c0.891,0.486,1.106,1.095,1.106,1.659c0,1.151-0.835,1.794-2.088,1.794
          c-0.486,0-1.072-0.126-1.331-0.316L54.915,21.839z"
        />
        <path
          className="svg_light"
          d="M60.659,16.299V17.8h1.095v1.219h-1.095v2.211c0,0.609,0.271,0.759,0.553,0.759
          c0.136,0,0.272-0.012,0.406-0.034v1.366c-0.332,0.072-0.672,0.106-1.012,0.101c-0.463,0-0.869-0.101-1.162-0.362
          c-0.339-0.305-0.53-0.759-0.53-1.67v-2.371h-0.644V17.8h0.644v-0.994L60.659,16.299z"
        />
        <path
          className="svg_light"
          d="M62.362,19.57c0-0.587-0.023-1.208-0.046-1.77h1.501l0.09,0.79h0.046c0.271-0.621,0.711-0.885,1.072-0.885
          c0.125-0.004,0.251,0.008,0.373,0.034v1.72c-0.125-0.02-0.252-0.028-0.379-0.023c-0.384,0.005-0.72,0.262-0.824,0.632
          c-0.058,0.186-0.085,0.381-0.078,0.575v2.708h-1.754V19.57z"
        />
        <path
          className="svg_light"
          d="M69.844,22.076c-0.006,0.427,0.024,0.853,0.09,1.275h-1.557l-0.09-0.53h-0.023
          c-0.299,0.401-0.774,0.633-1.275,0.621c-0.885,0-1.517-0.733-1.517-1.727c0-1.49,1.354-2.076,2.607-2.088v-0.101
          c0-0.305-0.282-0.541-0.733-0.541c-0.43-0.007-0.853,0.108-1.22,0.333l-0.305-1.162c0.591-0.298,1.245-0.453,1.907-0.451
          c1.93,0,2.122,1.377,2.122,2.449L69.844,22.076z M68.13,20.722c-0.506,0.011-1.027,0.215-1.027,0.802
          c0,0.474,0.282,0.655,0.474,0.655c0.225,0.008,0.431-0.125,0.518-0.333c0.025-0.073,0.037-0.149,0.034-0.226L68.13,20.722z"
        />
        <path className="svg_light" d="M70.701,15.542h1.747v7.809h-1.747V15.542z" />
        <path
          className="svg_light"
          d="M75.036,16.321c0.024,0.474-0.341,0.878-0.815,0.902c-0.023,0.001-0.047,0.001-0.07,0.001
          c-0.466-0.004-0.84-0.384-0.837-0.85c0-0.018,0.001-0.035,0.002-0.053c-0.035-0.469,0.317-0.877,0.785-0.912
          c0.024-0.002,0.048-0.003,0.072-0.002C74.651,15.407,75.036,15.756,75.036,16.321z M73.32,23.352V17.8h1.749v5.552H73.32z"
        />
        <path
          className="svg_light"
          d="M80.023,22.076c-0.006,0.427,0.024,0.853,0.09,1.275h-1.557l-0.09-0.53h-0.023
          c-0.299,0.401-0.774,0.633-1.275,0.621c-0.885,0-1.517-0.733-1.517-1.727c0-1.49,1.354-2.076,2.607-2.088v-0.101
          c0-0.305-0.282-0.541-0.733-0.541c-0.432-0.008-0.858,0.107-1.227,0.333l-0.31-1.157c0.591-0.298,1.245-0.453,1.907-0.451
          c1.93,0,2.122,1.377,2.122,2.449L80.023,22.076z M78.308,20.722c-0.506,0.011-1.027,0.215-1.027,0.802
          c0,0.474,0.282,0.655,0.474,0.655c0.225,0.008,0.431-0.125,0.518-0.333c0.025-0.073,0.037-0.149,0.034-0.226V20.722z"
        />
        <path
          className="svg_light"
          d="M80.87,19.57c0-0.587-0.023-1.208-0.046-1.77h1.501l0.09,0.632h0.023c0.311-0.454,0.827-0.725,1.377-0.722
          c1.173,0,1.535,0.96,1.535,2.15v3.492H83.6v-3.43c0-0.379-0.101-0.745-0.451-0.745c-0.192,0-0.339,0.113-0.44,0.327
          c-0.063,0.166-0.093,0.342-0.09,0.52v3.328H80.87V19.57z"
        />
        <path
          className="svg_light"
          d="M89.013,15.746h1.749v5.058c0,2.402-1.219,2.64-2.291,2.64c-0.28,0.005-0.558-0.038-0.823-0.126l0.15-1.472
          c0.164,0.048,0.335,0.071,0.506,0.068c0.35,0,0.711-0.147,0.711-1.027L89.013,15.746z"
        />
        <path
          className="svg_light"
          d="M93.068,21.298c0.023,0.506,0.451,0.813,1.116,0.813c0.38-0.004,0.756-0.065,1.118-0.181l0.215,1.242
          c-0.531,0.171-1.086,0.256-1.644,0.253c-1.591,0-2.482-0.96-2.482-2.708c0-1.897,1.061-3.002,2.37-3.002
          c1.219,0,2.023,0.835,2.023,2.697c0.009,0.298-0.01,0.597-0.057,0.891L93.068,21.298z M94.206,20.091
          c0-0.541-0.09-1.128-0.541-1.128c-0.451,0-0.598,0.655-0.598,1.128L94.206,20.091z"
        />
        <path
          className="svg_light"
          d="M97.774,17.8l0.192,2.257c0.057,0.609,0.113,1.138,0.147,1.644h0.034c0.078-0.506,0.181-1.095,0.282-1.625
          l0.429-2.276h1.343l0.406,2.234c0.113,0.632,0.204,1.162,0.259,1.67h0.023c0.034-0.497,0.08-1.084,0.147-1.67l0.259-2.234h1.726
          l-1.444,5.552h-1.501l-0.315-1.613c-0.122-0.581-0.213-1.169-0.271-1.76h-0.023c-0.068,0.593-0.174,1.181-0.316,1.76l-0.402,1.613
          h-1.495L95.889,17.8H97.774z"
        />
        <path
          className="svg_light"
          d="M105.153,16.321c0.024,0.474-0.341,0.878-0.815,0.902c-0.023,0.001-0.047,0.001-0.07,0.001
          c-0.466-0.004-0.84-0.384-0.837-0.85c0-0.018,0.001-0.035,0.002-0.053c-0.034-0.469,0.319-0.878,0.788-0.912
          c0.023-0.002,0.046-0.002,0.069-0.002C104.77,15.407,105.153,15.756,105.153,16.321z M103.438,23.352V17.8h1.749v5.552H103.438z"
        />
        <path
          className="svg_light"
          d="M106.068,21.839c0.321,0.18,0.681,0.281,1.049,0.293c0.327,0,0.506-0.113,0.506-0.362
          s-0.169-0.362-0.621-0.609c-0.981-0.53-1.128-1.151-1.128-1.602c0-1.038,0.733-1.851,1.952-1.851
          c0.409-0.002,0.813,0.084,1.185,0.253l-0.271,1.264c-0.242-0.135-0.513-0.209-0.79-0.215c-0.339,0-0.486,0.169-0.486,0.373
          c0,0.204,0.126,0.305,0.632,0.587c0.891,0.486,1.106,1.095,1.106,1.659c0,1.151-0.835,1.794-2.088,1.794
          c-0.486,0-1.072-0.126-1.331-0.316L106.068,21.839z"
        />
        <path
          className="svg_light"
          d="M109.679,15.542h1.749v2.832h0.023c0.13-0.185,0.295-0.342,0.486-0.463c0.232-0.131,0.493-0.201,0.759-0.204
          c1.151,0,1.467,1.004,1.467,2.415v3.228h-1.756v-3.288c0-0.474-0.078-0.891-0.463-0.891c-0.181,0-0.35,0.08-0.451,0.373
          c-0.037,0.136-0.06,0.276-0.068,0.417v3.389h-1.744V15.542z"
        />
        <path
          className="svg_light"
          d="M117.262,23.352v-7.606h1.592l1.072,2.731c0.192,0.486,0.553,1.444,0.745,2.032h0.023
          c-0.046-0.621-0.169-2.099-0.169-3.533v-1.23h1.517v7.606h-1.586l-1.027-2.562c-0.282-0.702-0.524-1.42-0.722-2.15h-0.023
          c0.034,0.655,0.101,1.918,0.101,3.414v1.297H117.262z"
        />
        <path
          className="svg_light"
          d="M124.235,21.298c0.023,0.506,0.451,0.813,1.117,0.813c0.38-0.004,0.756-0.065,1.118-0.181l0.215,1.242
          c-0.531,0.171-1.086,0.256-1.644,0.253c-1.591,0-2.482-0.96-2.482-2.708c0-1.897,1.061-3.002,2.37-3.002
          c1.219,0,2.023,0.835,2.023,2.697c0.009,0.298-0.01,0.597-0.057,0.891L124.235,21.298z M125.373,20.091
          c0-0.541-0.09-1.128-0.541-1.128c-0.451,0-0.598,0.655-0.598,1.128L125.373,20.091z"
        />
        <path
          className="svg_light"
          d="M128.941,17.8l0.192,2.257c0.057,0.609,0.113,1.138,0.147,1.644h0.034c0.078-0.506,0.181-1.095,0.282-1.625
          l0.429-2.276h1.347l0.406,2.234c0.113,0.632,0.204,1.162,0.259,1.67h0.023c0.034-0.497,0.08-1.084,0.147-1.67l0.257-2.234h1.726
          l-1.444,5.552h-1.5l-0.316-1.613c-0.122-0.581-0.213-1.169-0.271-1.76h-0.023c-0.068,0.593-0.174,1.181-0.316,1.76l-0.395,1.613
          h-1.503l-1.366-5.552H128.941z"
        />
        <path
          className="svg_light"
          d="M134.533,21.839c0.321,0.18,0.681,0.281,1.049,0.293c0.327,0,0.506-0.113,0.506-0.362
          s-0.169-0.362-0.621-0.609c-0.981-0.53-1.128-1.151-1.128-1.602c0-1.038,0.733-1.851,1.952-1.851
          c0.409-0.002,0.813,0.084,1.185,0.253l-0.271,1.264c-0.242-0.135-0.513-0.209-0.79-0.215c-0.339,0-0.486,0.169-0.486,0.373
          c0,0.204,0.126,0.305,0.632,0.587c0.891,0.486,1.106,1.095,1.106,1.659c0,1.151-0.835,1.794-2.088,1.794
          c-0.486,0-1.072-0.126-1.331-0.316L134.533,21.839z"
        />
        <path
          className="svg_light"
          d="M49.761,15.903h-0.559V15.65h1.479v0.253h-0.563v1.425h-0.358V15.903z"
        />
        <path
          className="svg_light"
          d="M51.278,15.642v0.675h0.828v-0.675h0.364v1.685h-0.363v-0.743h-0.829v0.742h-0.357v-1.684H51.278z"
        />
        <path
          className="svg_light"
          d="M53.988,16.579h-0.737v0.496h0.826v0.253h-1.184v-1.685h1.138v0.253h-0.78v0.435h0.737V16.579z"
        />
      </g>
    </g> */}
  </PageSvg>
);
const MrecSidebarArticle = (props) => (
  <PageSvg {...props} viewBox="0 0 300 300">
    <rect key="1" x="189" y="5" className="svg_grey" width="67" height="134" />
    <g key="2">
      <polygon
        className="svg_grey"
        points="46,7 46,17 46,27 102.9,27 102.9,17 178,17 178,7 		"
      />
      <polygon
        className="svg_grey"
        points="46,30 46,48 46,53 104,53 104,48 179,48 179,30 		"
      />
      <rect x="46" y="59" className="svg_grey" width="50" height="4" />
    </g>
    <g key="3">
      <rect x="46" y="69" className="svg_grey" width="136" height="85" />
      <polygon
        className="svg_grey"
        points="182,157 46,157 46,159 46,160 46,163 84,163 84,160 182,160 		"
      />
    </g>
    <rect
      key="4"
      x="189"
      y="146"
      className="svg_highlight"
      width="67"
      height="57"
    />
    <g key="5">
      <polygon
        className="svg_grey"
        points="46,168 46,196 46,201 58,201 58,196 182,196 182,168 		"
      />
      <polygon
        className="svg_grey"
        points="181,208 46,208 46,217 46,218 46,223 121,223 121,218 181,218 		"
      />
      <rect x="80" y="230" className="svg_grey" width="68" height="57" />
      <rect x="46" y="293" className="svg_grey" width="136" height="7" />
    </g>
  </PageSvg>
);
const HalfPageSidebarArticle = (props) => (
  <PageSvg {...props} viewBox="0 0 300 300">
    <rect
      key="1"
      x="189"
      y="5"
      className="svg_highlight"
      width="67"
      height="134"
    />
    <g key="2">
      <polygon
        className="svg_grey"
        points="46,7 46,17 46,27 102.9,27 102.9,17 178,17 178,7 		"
      />
      <polygon
        className="svg_grey"
        points="46,30 46,48 46,53 104,53 104,48 179,48 179,30 		"
      />
      <rect x="46" y="59" className="svg_grey" width="50" height="4" />
    </g>
    <g key="3">
      <rect x="46" y="69" className="svg_grey" width="136" height="85" />
      <polygon
        className="svg_grey"
        points="182,157 46,157 46,159 46,160 46,163 84,163 84,160 182,160 		"
      />
    </g>
    <rect key="4" x="189" y="146" className="svg_grey" width="67" height="57" />
    <g key="5">
      <polygon
        className="svg_grey"
        points="46,168 46,196 46,201 58,201 58,196 182,196 182,168 		"
      />
      <polygon
        className="svg_grey"
        points="181,208 46,208 46,217 46,218 46,223 121,223 121,218 181,218 		"
      />
      <rect x="80" y="230" className="svg_grey" width="68" height="57" />
      <rect x="46" y="293" className="svg_grey" width="136" height="7" />
    </g>
  </PageSvg>
);

const SponsoredContent = (props) => {

  return (

      <PageSvg {...props} viewBox="0 0 300 300">
        <g key="1">
          <rect x="63.3" y="89" className="svg_grey" width="97" height="8" />
          <rect x="40" y="101" className="svg_grey" width="46" height="30" />
          <rect x="89" y="101" className="svg_grey" width="46" height="30" />
          <rect x="138" y="101" className="svg_grey" width="46" height="30" />
        </g>
        <rect
          key="2"
          x="192.6"
          y="1"
          className="svg_grey"
          width="67"
          height="85"
        />
        <rect
          key="3"
          x="192.6"
          y="96"
          className="svg_grey"
          width="67"
          height="56"
        />
        <g key="4">
          <rect x="40.4" y="1" className="svg_grey" width="144" height="77" />
          <rect x="53.7" y="37" className="svg_white" width="118" height="8" />
          <rect x="82.7" y="47" className="svg_white" width="60" height="8" />
          <rect x="58.7" y="60" className="svg_white" width="108" height="3" />
          <rect x="103.7" y="68" className="svg_white" width="18" height="3" />
          <rect x="60.2" y="64" className="svg_white" width="105" height="3" />
        </g>
        <rect
          key="5"
          x="39.5"
          y="143"
          className="svg_grey"
          width="144"
          height="43"
        />
        <g key="6">
          <rect
            x="39.5"
            y="194"
            className="svg_highlight"
            width="144"
            height="96"
          />
          <rect
            x="47.5"
            y="202"
            className="svg_white"
            width="129"
            height="61"
          />
          <rect x="47.5" y="268" className="svg_white" width="72" height="4" />
          <rect x="47.5" y="276" className="svg_white" width="75" height="3" />
          <rect x="47.5" y="281" className="svg_white" width="45" height="3" />
        </g>
        <rect
          key="7"
          x="192.5"
          y="162"
          className="svg_grey"
          width="67"
          height="134"
        />
      </PageSvg>
  );
};

const svgComponents = {
  FullPage,
  HalfPage,
  QuarterPage,
  EightPage,
  Module,
  FrontCoverStrip,
  Interstitial,
  Banner,
  EmailBanner,
  MrecSidebar,
  MrecInline,
  MrecSidebarArticle,
  HalfPageSidebar,
  HalfPageSidebarArticle,
  Leaderboard,
  Billboard,
  SponsoredContent,
};

const AnimatedSVG = ({ component, image, item }) => {
  const Component = svgComponents[component];
  return svgComponents[component] ? <Component image={image} item={item}/> : null;
};
export default AnimatedSVG;
